import { Configuration } from './generated';
import Keycloak from 'keycloak-js';

const TOKEN_REFRESH_BUFFER_S = 30;

let keycloakInstance: Keycloak | null = null;

export function setKeycloakInstance(kc: Keycloak) {
  keycloakInstance = kc;
}

async function getFreshToken(): Promise<string> {
  if (!keycloakInstance) return '';
  try {
    await keycloakInstance.updateToken(TOKEN_REFRESH_BUFFER_S);
  } catch {
    keycloakInstance.login();
    return '';
  }
  return keycloakInstance.token ?? '';
}

export function createApiConfiguration(): Configuration {
  return new Configuration({
    basePath: window._env_?.API_BASE_URL,
    accessToken: getFreshToken,
  });
}
